import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { Navigate } from "react-router-dom";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";
import CustomPhoneInput from "components/PublicPagesReusable/CustomPhoneInput";
import NocBanner from "components/PublicPagesReusable/NocBanner";
import TestSection from "components/PublicPagesReusable/TestSection";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import ExamSkillsSection from "components/PublicPagesReusable/ExamSkillsSection";
import Globe from "assets/images/public-pages/green-globe.svg"
import Growth from "assets/images/public-pages/green-growth.svg"
import Idea from "assets/images/public-pages/green-idea-2.svg"
import Collab from "assets/images/public-pages/green-collab.svg"
import WorkBalance from "assets/images/public-pages/green-balance.svg"
import Work from "assets/images/public-pages/green-work.svg"
import "../assets/css/PteConsultation.css";

function Contact(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [flag, setFlag] = useState(false);
  const [lockSubmit, setLockSubmit] = useState(false);
  const [isDialCodeSelected, setIsDialCodeSelected] = useState(null);
  const [, setRender] = useState(false);
  const [exambefore, setExamBefore] = useState("yes");
  const [teaching, setTeaching] = useState("yes");
  const [score, setScore] = useState("");
  const [location, setLocation] = useState("");
  const [number, setNumber] = useState("");
  const [experience, setExperience] = useState("");
  const [start, setStart] = useState("");
  const [file, setFile] = useState("");
  const [interest_location, setInterestLocation] = useState("");
  const [position, setPosition] = useState("");
  const forceUpdate = () => setRender((prev) => !prev);
  const [errors, setErrors] = useState({});

  const validator = useRef(
    new SimpleReactValidator({
      messages: {
        alpha_space: "Allowed only letters and spaces.",
      },
      validators: {
        nameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Full Name is required",
        },
        positionMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Position is required",
        },
        exambeforeMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Exam Before is required",
        },
        scoreMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Score is required",
        },
        locationMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Location is required",
        },
        interestlocationMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Interest Location is required",
        },
        phoneMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Phone Number is required",
        },
        dialCodeRequired: {
          rule: () => false,
          message: "Please select a dial code",
        },
        phoneValid: {
          rule: (val) => {
            if (!val) return false;
            return isValidPhoneNumber(val);
          },
          required: true,
          message: "Please enter a valid phone number for the selected country",
        },
        teachingMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Teaching is required",
        },
        startMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Start Date is required",
        },
        resumeMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "File is required",
        },
      },
    })
  );

  useEffect(() => {
    if (isDialCodeSelected == false) {
      validator.current.showMessageFor("Enter Phone Number");
    }
  }, [isDialCodeSelected]);

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);


    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "exambefore":
        setExamBefore(value);
        break;
      case "teaching":
        setTeaching(value);
        break;
      case "score":
        setScore(value);
        break;
      case "location":
        setLocation(value);
        break;
      case "number":
        setNumber(value);
        break;
      case "experience":
        setExperience(value);
        break;
      case "start":
        setStart(value);
        break;
      case "interest_location":
        setInterestLocation(value);
        break;
      case "position":
        setPosition(value);
        break;
      default:
        break;
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (validator.current.allValid() && !lockSubmit) {
      setLockSubmit(true);

      let bodyFormData = new FormData();
      bodyFormData.append("name", name);
      bodyFormData.append("exambefore", exambefore);
      bodyFormData.append("score", score);
      bodyFormData.append("location", location);
      bodyFormData.append("number", number);
      bodyFormData.append("experience", teaching);
      bodyFormData.append("start", start);
      bodyFormData.append("interest_location", interest_location);
      bodyFormData.append("position", position);
      if (file) {
        bodyFormData.append("file", file);
      }

      API({
        method: "POST",
        url: "post/join-us",
        data: bodyFormData,
      })
        .then((data) => {
          console.log(data);

          setSubmit(true);
          setLockSubmit(false);

          setName("");
          setExamBefore("");
          setScore("");
          setLocation("");
          setNumber("");
          setExperience("");
          setStart("");
          setInterestLocation("");
          setPosition("");
          setFile("");
          setFlag(true);

          store.dispatch(
            setAlert({
              flag: true,
              type: 1,
              message: data.data.response.message,
            })
          );
        })
        .catch(() => {
          setLockSubmit(false);
        });
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };
  if (flag) {
    return <Navigate to="/thank-you" replace />;
  }

  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text text-center">
        Join the Team Behind <br />
        <span className="fw-600 text-success">Australia's #1</span> PTE Platform.
        {/* <br /> */}
      </h1>
    );
  };

  const heroData = {
    badge: "We're Growing",
    title: heroWorkTitle,
    subtitle: "We're on a mission to help students worldwide achieve their language goals. If you're passionate about education and technology, we'd love to hear from you.",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "10K+", label: "Students" },
        { value: "85%", label: "First-Attempt Success" },
        { value: "4.8★", label: "Google Rating" }
      ]
    },
    btnText: "Drop Your Resume"
  };

  const testData = {
    title: 'Interested? We’d Love To ',
    highlight: "Hear From You.",
    topDescription: "We're always looking for talented, passionate people to join our team. Drop your resume and tell us a bit about yourself — we'll be in touch if there's a fit.",
    list: [
      "No specific role required — apply anyway",
      "We review every application personally",
      "We'll respond within 7 business days",
      "Open to all experience levels"
    ]
  };

  const contentSection = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Why People<br /><span className="text-success FS40FW600"> Love Working Here </span>
      </h3>
    )
  }
  const examCardData = [
    {
      icon: Work,
      title: "Meaningful Work",
      content: `<div>Everything we build helps students achieve their dreams — whether that's studying abroad, getting PR, or advancing their career.</div>`
    },
    {
      icon: Growth,
      title: "Growth & Learning",
      content: `<div>Work alongside experienced educators and technologists. We invest in your development because your growth drives ours.</div>`
    },
    {
      icon: Collab,
      title: "Collaborative Culture",
      content: `<div>A supportive, no-ego environment where every voice matters. We celebrate wins together and learn from challenges as a team.</div>`
    },
    {
      icon: Globe,
      title: "Global Impact",
      content: `<div>Our platform serves students across 12+ countries. Your work reaches thousands of learners around the world.</div>`
    },
    {
      icon: Idea,
      title: "Innovation-Driven",
      content: `<div>We use AI-powered technology to redefine test preparation. You'll work with cutting-edge tools and ideas every day.</div>`
    },
    {
      icon: WorkBalance,
      title: "Work-Life Balance",
      content: `<div>Flexible schedules, a positive workplace, and a team that respects your time outside of work.</div>`
    }
  ]
  const handleBlur = (field) => () => {
    const message = validateField(field, formData[field]);
    setErrors((prev) => {
      const next = { ...prev };
      if (message) next[field] = message;
      else delete next[field];
      return next;
    });
  };
  return (
    <>
      <Helmet>
        <title>Join Our Team | On-Campus and Remote Work | LA Language Academy</title>
        <meta name="description" content="Join Our Team and Work from anywhere. We offer on-campus and remote work. We are hiring PTE tutors and admin staff, both on-campus and online. Join today!" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/join-us`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Join Our Team | On-Campus and Remote Work | LA Language Academy" />
        <meta name="twitter:description" content="Join Our Team and Work from anywhere. We offer on-campus and remote work. We are hiring PTE tutors and admin staff, both on-campus and online. Join today!" />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/join-us`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Join Our Team | On-Campus and Remote Work | LA Language Academy" />
        <meta property="og:description" content="Join Our Team and Work from anywhere. We offer on-campus and remote work. We are hiring PTE tutors and admin staff, both on-campus and online. Join today!" />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design career-page-section">
        <Header />
        <NocBanner data={heroData} extraClass={"contact-hero-section career-page"} extraClass2={"align-items-start"} />
        <ExamSkillsSection
          contentSection={contentSection}
          subtitle="Training In Parramatta"
          ctaText="Send Your CV"
          onCtaClick={"mailto:careers@languageacademy.com.au"}
          cards={examCardData}
          description={"We're a close-knit team that values growth, creativity, and making a real difference in students' lives."}
        />
        <div>
          <TestSection
            data={testData}
            bgColor={"#fffff"}
            color={"#0D1830"}
            extraClass={"custom-list-spacing"}
            listingClass={"career-page-listing"}
            icon={"/images/web-new-images/icons/green-check.svg"}
          />
          <form onSubmit={submitForm} noValidate>
            <section className="form-page-wrapper joinForm p-0" id="joinForm">
              <div className="custom-container">
                <div className="row franchFormInr">
                  <div className="col-sm-12 formOuter pl-5 pr-5">
                    <div className="pte-consultation__form" style={{ maxWidth: "100%", gap: "23px" }}>
                      <div className="audio-transcript-text p-0 border-0">
                        <p className="FS28 fw-600" style={{ color: "#19181C" }}>
                          Drop Your Resume
                        </p>
                        <span className="FS15FW400">Tell us who you are — we'll take it from there.</span>
                        {/* <hr/> */}
                      </div>
                      <div className="form-content mt-4 d-flex flex-column gap-4">
                        <div className="pte-consultation__row gap-3">
                          <label className="pte-consultation__field">
                            <span className="pte-consultation__label">Full Name*</span>
                            <input
                              className="pte-consultation__input"
                              type="text"
                              placeholder="Enter Full Name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                            {validator.current.message("Full Name", name, "nameMatch") && <span className="pte-consultation__error">{validator.current.message("Full Name", name, "nameMatch")}</span>}
                          </label>

                          <label className="pte-consultation__field">
                            <span className="pte-consultation__label">Position you are applying for*</span>
                            <select
                              className="pte-consultation__input pte-consultation__select"
                              value={position}
                              onChange={(e) => setPosition(e.target.value)}
                            >
                              <option value="">Select position</option>
                              <option value="PTE Trainer">PTE Trainer</option>
                              <option value="Admin">Admin</option>
                              <option value="Other">Other</option>
                            </select>
                            {validator.current.message("Position", position, "positionMatch") && <span className="pte-consultation__error">{validator.current.message("Position", position, "positionMatch")}</span>}
                          </label>

                          <div className="pte-consultation__field">
                            <span className="pte-consultation__label">Have you taken the PTE exam before?*</span>
                            <div className="d-flex align-items-center gap-3">
                              <label className={exambefore === "yes" ? "radio-selected" : "radio-unselected"}>
                                <input className="form-check-input radio-input" type="radio" name="exambefore" value="yes" checked={exambefore === "yes"} onChange={(e) => setExamBefore(e.target.value)} />
                                <span>Yes</span>
                              </label>
                              <label className={exambefore === "no" ? "radio-selected" : "radio-unselected"}>
                                <input className="form-check-input radio-input" type="radio" name="exambefore" value="no" checked={exambefore === "no"} onChange={(e) => setExamBefore(e.target.value)} />
                                <span>No</span>
                              </label>
                            </div>
                            {validator.current.message("Exam Before", exambefore, "exambeforeMatch") && <span className="pte-consultation__error">{validator.current.message("Exam Before", exambefore, "exambeforeMatch")}</span>}
                          </div>
                        </div>

                        <div className="pte-consultation__row gap-3">
                          <label className="pte-consultation__field">
                            <span className="pte-consultation__label">If yes, what was your score?*</span>
                            <input
                              className="pte-consultation__input"
                              type="text"
                              placeholder="Enter Score"
                              value={score}
                              onChange={(e) => setScore(e.target.value)}
                            />
                            {validator.current.message("Score", score, "scoreMatch") && <span className="pte-consultation__error">{validator.current.message("Score", score, "scoreMatch")}</span>}
                          </label>

                          <label className="pte-consultation__field">
                            <span className="pte-consultation__label">Where are you located?*</span>
                            <input
                              className="pte-consultation__input"
                              type="text"
                              placeholder="Enter Location"
                              value={location}
                              onChange={(e) => setLocation(e.target.value)}
                            />
                            {validator.current.message("Location", location, "locationMatch") && <span className="pte-consultation__error">{validator.current.message("Location", location, "locationMatch")}</span>}
                          </label>

                          <label className="pte-consultation__field">
                            <span className="pte-consultation__label">Location you are Interested to work at*</span>
                            <select
                              className="pte-consultation__input pte-consultation__select"
                              value={interest_location}
                              onChange={(e) => setInterestLocation(e.target.value)}
                            >
                              <option value="">Select location</option>
                              <option value="Parramatta">Parramatta</option>
                              <option value="Jalandhar">Jalandhar</option>
                              <option value="Gurdaspur">Gurdaspur</option>
                              <option value="Work from home">Work from home</option>
                            </select>
                            {validator.current.message("Interest Location", interest_location, "interestlocationMatch") && <span className="pte-consultation__error">{validator.current.message("Interest Location", interest_location, "interestlocationMatch")}</span>}
                          </label>
                        </div>

                        <div className="pte-consultation__row gap-3">
                          <div className="pte-consultation__field">
                            <span className="pte-consultation__label">Phone Number</span>
                            <CustomPhoneInput
                              value={number}
                              onChange={(val) => setNumber(val || "")}
                            />
                            {number === ""
                              ? validator.current.message("Enter Phone Number", number, "phoneMatch") && <span className="pte-consultation__error">{validator.current.message("Enter Phone Number", number, "phoneMatch")}</span>
                              : validator.current.message("Enter Phone Number", number, "phoneValid") && <span className="pte-consultation__error">{validator.current.message("Enter Phone Number", number, "phoneValid")}</span>}
                          </div>

                          <div className="pte-consultation__field">
                            <span className="pte-consultation__label">Do you have any experience in teaching?*</span>
                            <div className="d-flex align-items-center gap-3">
                              <label className={teaching === "yes" ? "radio-selected" : "radio-unselected"}>
                                <input className="form-check-input radio-input" type="radio" name="teaching" value="yes" checked={teaching === "yes"} onChange={(e) => setTeaching(e.target.value)} />
                                <span>Yes</span>
                              </label>
                              <label className={teaching === "no" ? "radio-selected" : "radio-unselected"}>
                                <input className="form-check-input radio-input" type="radio" name="teaching" value="no" checked={teaching === "no"} onChange={(e) => setTeaching(e.target.value)} />
                                <span>No</span>
                              </label>
                            </div>
                            {validator.current.message("Teaching", teaching, "teachingMatch") && <span className="pte-consultation__error">{validator.current.message("Teaching", teaching, "teachingMatch")}</span>}
                          </div>
                          <div className="fieldOuter pte-consultation__field">
                            <span className="pte-consultation__label">When can you start?*</span>
                            <div className="form-input-outer form-calendar-input">
                              <input
                                className="pte-consultation__input"
                                type="date"
                                value={start}
                                onChange={(e) => setStart(e.target.value)}
                              />
                            </div>
                            {validator.current.message("Start", start, "startMatch")}
                          </div>
                        </div>
                        {/* </div> */}
                        <label className="pte-consultation__field" style={{ flex: "none" }}>
                          <span className="pte-consultation__label">Upload Resume/CV*</span>
                          <div className="form-input-outer form-resume-input">
                            <input
                              className="pte-consultation__input join-file-input "
                              type="file"
                              onChange={handleFileChange}
                            />
                          </div>
                          {validator.current.message("File", file, "resumeMatch") && <span className="pte-consultation__error">{validator.current.message("File", file, "resumeMatch")}</span>}
                        </label>
                        <div className="pte-consultation__submit-wrap">
                          {!lockSubmit ? (
                            <button className="primary-btn" type="submit">
                              Submit Application
                              <img src="/images/web-new-images/new-dark-arrow.svg" alt="LA" />
                            </button>
                          ) : (
                            <button className="primary-btn">
                              Processing...
                              <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </form>
          <AppBannerCustom
            appName="PTE"
            description="PTE PRACTICE"
            mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
            playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
            appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
          />
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Contact;
